module.exports = __webpack_public_path__ + "img/ES2048.bcbe1519.svg";